import { CreditCard } from "lucide-react";
import { Panel } from "./Panel";
import { L } from "@/i18n";

const Unavailable = () => (
  <div className="flex flex-col items-center justify-center text-center py-8" data-testid="subscription-unavailable">
    <div className="h-10 w-10 rounded-md bg-slate-800 grid place-items-center mb-3">
      <CreditCard className="h-5 w-5 text-slate-500" />
    </div>
    <p className="text-sm text-slate-300">{L("Subscription data unavailable", "Dados de subscrição indisponíveis")}</p>
    <p className="mt-1 max-w-xs text-xs text-slate-500">
      {L("The production API does not yet return each user's active plan (active_plan) in /api/admin/users. This card fills in automatically once the field is available.", "A API de produção ainda não devolve o plano ativo (active_plan) de cada utilizador em /api/admin/users. Este cartão preenche-se automaticamente quando o campo existir.")}
    </p>
  </div>
);

export const SubscriptionCard = ({ plans, available, total }) => (
  <Panel testId="card-subscription-distribution" className="lg:col-span-4" title={L("Subscriptions", "Subscrições")} subtitle="Free · Individual · Flex · Full Access">
    {!available ? (
      <Unavailable />
    ) : (
      <ul className="space-y-4">
        {plans.map((p) => {
          const pct = total ? Math.round((p.count / total) * 100) : 0;
          return (
            <li key={p.key} data-testid={`subscription-${p.key}`}>
              <div className="flex justify-between text-xs mb-1.5">
                <span className="text-slate-300">{p.label}</span>
                <span className="font-mono text-slate-400">{p.count} · {pct}%</span>
              </div>
              <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden">
                <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct}%`, background: p.color }} />
              </div>
            </li>
          );
        })}
      </ul>
    )}
  </Panel>
);
